export default __webpack_public_path__ + "static/media/effra_heavy-webfont.dba16a59.woff";